import React, { useEffect, useState } from 'react';
import { Route, RouteProps, useHistory, useLocation } from 'react-router-dom';

import { useAuth } from '../authentication/AuthenticationContext';
import { useGameTheme } from '../GameThemeContext';
import { useRedirectUrl } from '../redirect-url/ProviderRedirectUrlContext';

interface Props {
  children: JSX.Element | JSX.Element[];
  authRoute: boolean
}

export function GuardRoute({ children, authRoute, ...rest }: Props & RouteProps): JSX.Element {
  const [authorized, setAuthorized] = useState<boolean>(false);

  const auth = useAuth();
  const theme = useGameTheme();
  const location = useLocation();
  const history = useHistory();
  const { setRedirect } = useRedirectUrl();

  useEffect(() => {
    if (auth.isUserLoad) {
      setAuthorized(false);
      if ((auth?.user && authRoute) || (!auth?.user && !authRoute)) {
        setAuthorized(true);
      } else {
        if (!auth?.user) {
          setRedirect(`${location.pathname}${location.search}`);
        }

        if (authRoute) {
          history.replace(`/auth/signin/${theme.gameId}`);
        } else {
          history.replace('/account');
        }
      }
    }
  }, [location.pathname, auth.isUserLoad, auth?.user]);

  return (
    <>
      {auth.isUserLoad && (!authRoute || auth?.user) && (
        <Route {...rest}>
          {authorized && children}
        </Route>
      )}
    </>
  );
}
